import { httpPut } from "../../../../../common/network/fetch";

export const ReportInvalidSupplierContactData = async (comment: string) => {
    const response = (await httpPut<{ supportTicket: { externalId: string } }>({
        url: `/user-data/invalid`, data: { comment },
    }));

    if ((response.supportTicket.externalId ?? "") !== "") {
        return response.supportTicket.externalId;
    } else {
        throw new Error("Unable to create ticket");
    }
};
